import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';
import UpdateProductBillingTypeMutation from '@/graphql/contracts/updateProductBillingType.mutation.gql';
import { UpdateProductBillingType, UpdateProductBillingTypeVariables }
  from '@/graphql/contracts/_generated_/updateProductBillingType.mutation';

export default function useUpdateProductBillingType() {
  const [updateProductBillingType, { loading, error }] = useMutation<
  UpdateProductBillingType,
  UpdateProductBillingTypeVariables
  >(UpdateProductBillingTypeMutation, {
    client: apolloClientContracts,
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });
  const updateBillingType = (fields: UpdateProductBillingTypeVariables, successCb?: () => void) => {
    updateProductBillingType({
      variables: { ...fields },
      onCompleted: () => {
        notificationService.open({
          title: 'Changing Billing Type',
          text: 'Product billing type successfully changed',
          type: 'success',
        });

        if (successCb) {
          successCb();
        }
      },
    });
  };

  return {
    updateBillingType,
    isLoadingUpdateBillingType: loading,
    errorUpdateBillingType: error,
  } as const;
}
